const SITE_URL = (
  (import.meta.env.VITE_SITE_URL as string) || 'https://allchinabuyspread.bond'
).replace(/\/+$/, '');

export function getSiteUrl(): string {
  return SITE_URL;
}

export function buildUrl(path: string): string {
  if (path === '/' || path === '') return `${SITE_URL}/`;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

function setMetaName(name: string, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setMetaProperty(property: string, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href: string): void {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function removeMetaName(name: string): void {
  document.head.querySelectorAll(`meta[name="${name}"]`).forEach((el) => el.remove());
}

export interface SeoData {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  ogType: string;
  ogTitle: string;
  ogDescription: string;
  ogUrl: string;
  twitterTitle: string;
  twitterDescription: string;
  robots?: string;
}

export function applySeo(data: SeoData): void {
  document.title = data.title;
  setMetaName('description', data.description);
  setMetaName('keywords', data.keywords);
  setCanonical(data.canonical);
  setMetaProperty('og:title', data.ogTitle);
  setMetaProperty('og:description', data.ogDescription);
  setMetaProperty('og:type', data.ogType);
  setMetaProperty('og:url', data.ogUrl);
  setMetaName('twitter:title', data.twitterTitle);
  setMetaName('twitter:description', data.twitterDescription);

  if (data.robots) {
    setMetaName('robots', data.robots);
  } else {
    removeMetaName('robots');
  }
}